var map = {
	"./en-AU.json5": [
		17670,
		836
	],
	"./en-CA.json5": [
		37982,
		478
	],
	"./en-US.json5": [
		40891,
		13
	],
	"./en.json5": [
		36501,
		324
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 54467;
module.exports = webpackAsyncContext;